import gql from 'graphql-tag'

export const barQuery = gql`
  query barQuery($id: String! = "0x000000000000000000000000000000000000000", $block: Block_height) {
    bar(id: $id, block: $block) {
      id
      totalSupply
      ratio
      xNvlsMinted
      xNvlsBurned
      nvlsStaked
      nvlsStakedUSD
      nvlsHarvested
      nvlsHarvestedUSD
      xNvlsAge
      xNvlsAgeDestroyed
      # histories(first: 1000) {
      #   id
      #   date
      #   timeframe
      #   nvlsStaked
      #   nvlsStakedUSD
      #   nvlsHarvested
      #   nvlsHarvestedUSD
      #   xNvlsAge
      #   xNvlsAgeDestroyed
      #   xNvlsMinted
      #   xNvlsBurned
      #   xNvlsSupply
      #   ratio
      # }
    }
  }
`

export const barHistoriesQuery = gql`
  query barHistoriesQuery {
    histories(first: 1000) {
      id
      date
      timeframe
      nvlsStaked
      nvlsStakedUSD
      nvlsHarvested
      nvlsHarvestedUSD
      xNvlsAge
      xNvlsAgeDestroyed
      xNvlsMinted
      xNvlsBurned
      xNvlsSupply
      ratio
    }
  }
`

export const barUserQuery = gql`
  query barUserQuery($id: String!) {
    user(id: $id) {
      id
      bar {
        totalSupply
        nvlsStaked
      }
      xNvls
      nvlsStaked
      nvlsStakedUSD
      nvlsHarvested
      nvlsHarvestedUSD
      xNvlsIn
      xNvlsOut
      xNvlsOffset
      xNvlsMinted
      xNvlsBurned
      nvlsIn
      nvlsOut
      usdIn
      usdOut
      createdAt
      createdAtBlock
    }
  }
`

export const feesQuery = gql`
  query feesQuery(
    $first: Int! = 1000
    $skip: Int! = 0
    $where: Fee_filter
    $orderBy: Fee_orderBy! = "createdAtTimestamp"
    $orderDirection: OrderDirection! = "desc"
  ) {
    fees(first: $first, skip: $skip, where: $where, orderBy: $orderBy, orderDirection: $orderDirection) {
      id
      amount
      createdAtTimestamp
    }
  }
`

export const barXnvlsQuery = gql`
  query barXnvlsQuery($block: Block_height) {
    xnvls(id: "xNvls", block: $block) {
      id
      nvlsHarvested
      nvlsStaked
      nvlsSupply
      nvlsXnvlsRatio
      totalFeeAmount
      transactionCount
      userCount
      xNvlsBurned
      xNvlsMinted
      xNvlsSupply
      xNvlsNvlsRatio
    }
  }
`

export const barXnvlsUserQuery = gql`
  query barXnvlsUserQuery($id: String!, $block: Block_height) {
    user(id: $id, block: $block) {
      id
      balance
      createdAtBlock
      createdAtTimestamp
      modifiedAtBlock
      modifiedAtTimestamp
      deposits(first: 1000, orderBy: timestamp, orderBy: desc, orderDirection: desc) {
        amount
        xNvlsNvlsRatio
        nvlsXnvlsRatio
        block
        id
        timestamp
        type
      }
      withdrawals(first: 1000, orderBy: timestamp, orderBy: desc, orderDirection: desc) {
        amount
        xNvlsNvlsRatio
        nvlsXnvlsRatio
        block
        id
        timestamp
        type
      }
    }
  }
`
